import {t} from 'i18next'
import {TicketPriority} from '../store/support/reducer'

export function getPercentSize(value: number, topValue: number) {
  if (value === 0 || topValue === 0) return '0%'
  return value / topValue * 100 + '%'
}

export function getPriorityName(value: TicketPriority) {
  switch (value) {
    case 'low': return t('common.low')
    case 'medium': return  t('common.medium')
    case 'high': return  t('common.high')
  }
}

export function getSourceName(value: string) {
  switch (value) {
    case 'ok': return 'OK'
    case 'vk': return 'VK'
    case 'fb': return 'Facebook'
    case 'tc': return 'True'
    case 'callapp': return 'CallApp'
    case 'telegramid': return 'telegram'
    case 'facebookid': return 'facebook'
    case 'linkedinid': return 'linkedIn'
    case 'vkid': return 'vk'
    case 'email': return 'e-mail'
    case 'fullname' : return 'full name'
    case 'twitterid' : return 'twitter'
    case 'instagramid' : return 'instagram'
    case 'instanavigation_person' : return 'Instaperson'
    case 'irbis_eye' : return 'Irbis Eye'
    case 'web_collection_phone' : return 'Webcoll Phone'
    case 'web_collection_email' : return 'Webcoll E-mail'
    case 'hbp' : return 'Have Been Pwned?'
    case 'smf' : return 'Social Media Finder'
    case 'glook' : return 'GLook'
    case 'glook_id' : return 'GLook'
    case 'insta_story': return 'Instasprofile'
    case 'threads': return 'Threads'
    case 'reddit': return 'Reddit'
    case 'snapchat': return 'Snapchat'
    case 'kyc_iban' : return 'IBAN'
    case 'kyc_company_enrich' : return 'Comp. Enrich'
    case 'kyc_vat_validate' : return 'VAT Validation'
    case 'web_collection_screenshot' : return 'Screenshot'
    case 'web_collection_scrape' : return 'Web Scrape'
    case 'geolocation' : return 'IP Geolocation'
    case 'geolocation_proxy': return 'Check Proxy'
    case 'breach_ip': return 'Breach IP'
    case 'breach_email': return 'Breach E-mail'
    case 'breach_phone': return 'Breach Phone'
    case 'breach_name': return 'Breach Name'
    case 'breach_username': return 'Breach ID'
    case 'geolocation_number' : return 'Geolocation by Phone Number'
    case 'email_domain_validator' : return 'E-mail domain validator'
    case 'country_fullname' : return 'Full Name by country'
    case 'sniper_api': return 'Sniper API'
    case 'VERIFICATION': return 'AI verification'
    case 'fb_api' : return 'Facebook'
    case 'instagram_api' : return 'Instagram'
    case 'vk_api' : return 'Vk'
    case 'ok_api' : return 'Ok'
    case 'x_api' : return 'X'
    case 'linkedin_api' : return 'LinkedIn'
    case 'tiktok_api' : return 'TikTok'
    case 'blsk_api' : return 'BlueSky'
    case 'mail_reveal' : return 'E-mail Reveal'
    case 'irbis_tiktok' : return 'TikTok'
    case 'bluesky_v3' : return 'BlueSky'
    case 'irbis_criminal': return 'Criminal Checks'
    case 'ssn_trace' : return 'SSN Trace'
    case 'nat_crim_check': return 'National Criminal Screening'
    case 'pep_nm_wls': return 'Watchlists, Politically Exposed Persons, Adverse Media Screening'
    case 'soc_sec_num_trace' : return 'SSN Trace (signzy)'
    case 'national_crime' : return 'National Criminal Screening (signzy)'
    case 'political_exposed': return 'Politically Exposed Persons (signzy)'
    case 'court_rec': return 'Court Records'
    case 'ars_wallet_screening': return 'ARS Wallet Screening'
    case 'fbProfile': return 'Facebook Profile (Profiler)'
    case 'redditProfile': return 'Reddit Profile'
    case 'threadsProfile': return 'Threads Profile'
    case 'fbPage': return 'Facebook Page (Profiler)'
    case 'instaProfile': return 'Instagram Profile (Profiler)'
    case 'linkedinProfile': return 'LinkedIn Profile (Profiler)'
    case 'linkedinPosts': return 'LinkedIn Posts (Profiler) (Out of date)'
    case 'xProfile': return 'X (Twitter) Profile (Profiler)'
    case 'vkProfile': return 'VK Profile (Profiler)'
    case 'okProfile': return 'OK Profile (Profiler)'
    case 'tiktokProfile': return 'TikTok Profile (Profiler)'
    case 'fbGroupProfile': return 'Facebook Group (Webint)'
    case 'vkWebintGroup': return 'VK Group (Webint)'
    case 'okWebintGroup': return 'OK Group (Webint)'
    case 'xWebintGroup': return 'X Group (Webint)'
    case 'keywords': return 'Keywords (Webint)'
    case 'adid_sftp': return 'AdID (sftp, by coordinates)'
    case 'adid_by_phone_sftp': return 'AdID (sftp, by phone number)'
    case 'adid_location_sftp': return 'AdID (sftp, get location by AdID)'
    case 'common_psychoprofile': return 'Psychoprofile and Summary'
    case 'image_insize': return 'Image Analysis'
    case 'sndr': return 'Irbis Sender'
    case 'osint profile': return 'OSINT Profile'
    case 'isr_public_rec': return 'Israel Public Records'
    case 'isr_public_rec_social': return 'Israel Public Records (ARS)'
    case 'company_id': return 'Company ID (Google dork)'
    case 'legal_decisions': return ' Legal Decisions (Google dork)'
    case 'perplexity': return 'Perplexity'
    case 'verdicts': return 'Verdicts'
    case 'sanctions_person_company': return 'Open Sanctions (Person/Company)'
    case 'sanctions_pep': return 'Open Sanctions (Politically Exposed Persons)'
    case 'watchlists': return 'Open Sanctions (Watchlists)'
    case 'webmii_social': return 'Webmii Social'
    case 'public_info': return 'Public Company Info'
    case 'conclude_report': return 'Conclude Report'
    default: return value
  }
}

export function getWebintName(value : string) {
  switch (value) {
  case 'quotaprofiler-lookup' : return 'Profiler Lookup'
  case 'quotaprofiler-crawler' : return 'Profiler Crawler'
  case 'quotaprofiler-cases' : return 'Profiler Cases'
  case 'quotaprofiler-periodic' : return 'Profiler Periodic'
  case 'quotaprofiler-monitoring' : return 'Profiler Monitoring'
  case 'quotawebint-lookup' : return 'WebInt Lookup' 
  case 'quotawebint-crawler': return 'WebInt Crawler'
  case 'quotawebint-cases': return 'WebInt Cases'
  case 'quotawebint-periodic': return 'WebInt Periodic'
  case 'quotawebint-monitoring': return 'WebInt Monitoring'
  }
}

export function genRandomHex(size: number) {
  return '#' + [...Array(size)].map(() => Math.floor(Math.random() * 16).toString(16)).join('')
}
